import { Link } from 'react-router-dom';
import { Calculator, Settings, Share2, ArrowRight } from 'lucide-react';

export function Landing() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-50 to-white dark:from-gray-900 dark:to-gray-800">
      {/* Hero Section */}
      <div className="pt-20 pb-16 text-center px-4">
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6">
          Print Shop Pricing
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-2xl mx-auto">
          Create your own professional pricing calculator for DTF and screen printing. 
          Share it with your customers and streamline your quote process.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/pricing" className="btn-primary">
            Create Your Calculator
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
          <Link to="/demo" className="btn-secondary">
            View Demo
          </Link>
        </div>
      </div>

      {/* Features Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Feature cards */}
          <div className="bg-white dark:bg-gray-800 rounded-xl p-8 shadow-lg">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <Calculator className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Professional Calculator
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              A beautiful, customizable calculator that handles both DTF and screen printing 
              pricing with support for multiple locations and quantities.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl p-8 shadow-lg">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <Settings className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Customizable Settings
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              Full control over pricing variables including shop rates, margins, 
              decoration costs, and handling fees. Update anytime as needed.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl p-8 shadow-lg">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <Share2 className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Easy Sharing
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              Get a unique URL for your calculator that you can share with customers. 
              They can price their orders instantly without contacting you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}